// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/head-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-head-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.rule-history-modal {
  width: 855px;
  max-width: none !important;
}

.add-currency-rule-modal {
  width: 662px;
  max-width: none !important;
}

.custom-enterprise-modal {
  max-width: 1018px !important;
}

.custom-enterprise-modal .modal-content {
  width: 1018px !important;
  height: 498px !important;
}

.custom-enterprise-modal .modal-body {
  height: 498px !important;
  padding: 0 !important;
}

/* Currency Conversion Table Styles */
.currency-conversion-table {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.currency-conversion-table thead th {
  background-color: #f8f9fa;
  font-weight: 500;
  font-size: 13px;
  color: #6c757d;
  text-transform: none;
  letter-spacing: 0;
}

.currency-conversion-table tbody tr {
  transition: background-color 0.15s ease-in-out;
}

.currency-conversion-table tbody tr:hover {
  background-color: #f8f9fa;
}

.currency-conversion-table td {
  vertical-align: middle;
  border: none;
  padding: 16px 20px;
}

.currency-conversion-table th {
  vertical-align: middle;
  border: none;
  padding: 16px 20px;
}

/* Action button styles */
.currency-conversion-table .btn-link:hover {
  background-color: #e9ecef;
  border-radius: 4px;
}

.currency-conversion-table .btn-link:focus {
  box-shadow: none;
  outline: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .currency-conversion-table th,
  .currency-conversion-table td {
    padding: 12px 16px;
    font-size: 13px;
  }

  .currency-conversion-table thead th {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/modal.css"],"names":[],"mappings":"AAAA;EACE,yDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE;uCACqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modal-head-bg {\n  background-image: url(\"../assets/images/head-bg.png\");\n  background-size: cover;\n}\n\n.rule-history-modal {\n  width: 855px;\n  max-width: none !important;\n}\n\n.add-currency-rule-modal {\n  width: 662px;\n  max-width: none !important;\n}\n\n.custom-enterprise-modal {\n  max-width: 1018px !important;\n}\n\n.custom-enterprise-modal .modal-content {\n  width: 1018px !important;\n  height: 498px !important;\n}\n\n.custom-enterprise-modal .modal-body {\n  height: 498px !important;\n  padding: 0 !important;\n}\n\n/* Currency Conversion Table Styles */\n.currency-conversion-table {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.currency-conversion-table thead th {\n  background-color: #f8f9fa;\n  font-weight: 500;\n  font-size: 13px;\n  color: #6c757d;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.currency-conversion-table tbody tr {\n  transition: background-color 0.15s ease-in-out;\n}\n\n.currency-conversion-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.currency-conversion-table td {\n  vertical-align: middle;\n  border: none;\n  padding: 16px 20px;\n}\n\n.currency-conversion-table th {\n  vertical-align: middle;\n  border: none;\n  padding: 16px 20px;\n}\n\n/* Action button styles */\n.currency-conversion-table .btn-link:hover {\n  background-color: #e9ecef;\n  border-radius: 4px;\n}\n\n.currency-conversion-table .btn-link:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .currency-conversion-table th,\n  .currency-conversion-table td {\n    padding: 12px 16px;\n    font-size: 13px;\n  }\n\n  .currency-conversion-table thead th {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
